import React from "react";
import Dashboard from "./components/OldDashboard";

export default function GeneralDashboard() {
  return <Dashboard programId={1} name="RS" />;
}
